import Component from './identification';
export default Component;
